import Vue from 'vue'

import { AdminConfig } from 'stylemix-vue-admin'

const $settings = Vue.observable({})

Object.defineProperty(Vue.prototype, '$settings', {
  get: () => $settings,
})

export default {
  created() {
    // This hook should only be executed for root component
    if (this.$root !== this) {
      return
    }

    this.$http.get('settings').then((response) => {
      Object.assign($settings, response.data)
      document.title = `${$settings.app_name} Console` ?? 'Console'
      if ($settings.logo_url) {
        AdminConfig.setLogo($settings.logo_url)
      }
    })
  },
}
